import React from 'react';
import {useIntl} from 'react-intl';

import Icon from 'brandComponents/Icon';
import Link from 'brandComponents/Link';
import {useURLs} from 'brandHooks/useURLs';

import messages from './messages';

import styles from './ProductCTA.module.scss';

const ProductCTA = () => {
	const intl = useIntl();
	const urls = useURLs();

	return (
		<div className={styles['product-detail__cta-container']}>
			<div className={styles['product-detail__cta']}>
				<Link to={urls.CUSTOMER_SERVICE}>
					<span>
						<Icon name="contact" width={20} height={20} />
						{intl.formatMessage(messages.descriptionCtaContactUs)}
					</span>
					<Icon name="arrow-right" width={20} height={20} classNames={styles['arrow']}/>
				</Link>
			</div>
		</div>
	);
};

export default ProductCTA;